module.exports = __webpack_public_path__ + "img/expert configuration.00130ffb.svg";